export const getNameForField = (id: string, name: string) => {
  return `${id}_${name}`;
};
